







































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { calMax, calMin } from '@/utils/common'
import * as echarts from 'echarts'
@Component({
  name: 'OrderStatistics'
})
export default class extends Vue {
  @Prop() private orderdata!: any
  @Prop() private overviewData!: any

  @Watch('orderdata')
  getData() {
    this.$nextTick(() => {
      this.initChart()
    })
  }
  initChart() {
    type EChartsOption = echarts.EChartsOption
    const chartDom = document.getElementById('ordermain') as any
    const myChart = echarts.init(chartDom)
    var option: any
    // 调用方法，获取数据的最大值&最小值
    var maxData1 = calMax(this.orderdata.data.amount)
    var minData1 = calMin(this.orderdata.data.amount)
    option = {
      tooltip: {
        trigger: 'axis',
        backgroundColor: '#fff', //背景颜色（此时为默认色）
        borderRadius: 2, //边框圆角
        textStyle: {
          color: '#333', //字体颜色
          fontSize: 12, //字体大小
          fontWeight: 300
        }
      },
      grid: {
        top: '5%',
        left: '0',
        right: '0',
        bottom: '12%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        axisLabel: {
          //X轴字体颜色
          textStyle: {
            color: '#666',
            fontSize: '12px'
          }
        },
        axisLine: {
          //X轴线颜色
          lineStyle: {
            color: '#E5E4E4',
            width: 1 //x轴线的宽度
          }
        },
        data: this.orderdata.data.date //后端传来的动态数据
      },
      yAxis: [
        //左侧值
        {
          type: 'value',
          min: minData1,
          max: maxData1,
          splitNumber: 5, //设置坐标轴的分割段数
          interval: (maxData1 - minData1) / 5, // 标轴分割间隔
          axisLabel: {
            textStyle: {
              color: '#666',
              fontSize: '12px'
            },
            formatter: function(v) {
              return v.toFixed(0) //0表示小数为0位，1表示1位小数，2表示2位小数
            }
          }
        }
      ],
      series: [
        {
          name: '订单总数',
          type: 'line',
          // stack: 'Total',
          smooth: true, //否平滑曲线
          showSymbol: false, //未显示鼠标上移的圆点
          symbolSize: 10,
          // symbol:"circle", //设置折线点定位实心点
          itemStyle: {
            normal: {
              color: '#FFD000',
              lineStyle: {
                color: '#FFD000'
              }
            },
            emphasis: {
              color: '#fff',
              borderWidth: 5,
              borderColor: '#FFC100'
            }
          },

          data: this.orderdata.data.amount
        },
        {
          name: '有效订单',
          type: 'line',
          // stack: 'Total',
          smooth: true, //否平滑曲线
          showSymbol: false, //未显示鼠标上移的圆点
          symbolSize: 10, //圆点大小
          // symbol:"circle", //设置折线点定位实心点
          itemStyle: {
            normal: {
              color: '#FD7F7F',
              lineStyle: {
                color: '#FD7F7F'
              }
            },
            emphasis: {
              // 圆点颜色
              color: '#fff',
              borderWidth: 5,
              borderColor: '#FD7F7F'
            }
          },

          data: this.orderdata.data.validNum
        }
      ]
    }
    option && myChart.setOption(option)
    window.addEventListener('resize', function() {
      myChart.resize()
    })
  }
}
